import CrudApi from './crud';

export const crud = new CrudApi('/schools/:schoolId/teachers', { only: ['index'] });
